import React from 'react'
import { upperFirst, camelCase } from 'lodash'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

import { IProps as IStatisticProps } from 'marketing-site/src/library/elements/Statistic'
import { Statistic } from 'marketing-site/src/library/elements/Statistic'
import { IStatistic as IContentfulStatistic } from 'marketing-site/@types/generated/contentful'
import { getHexColorFromName } from 'marketing-site/src/library/utils'
import { getSnakeCaseFromString } from '../components/ContentfulStatistics'

export const ContentfulStatistic = (statistic: IContentfulStatistic) => {
  return <Statistic {...transformStat(statistic)} />
}

const transformBackgroundColor = (colorName: string) => {
  const parsedColorName =
    colorName === 'Extra light blue' ? 'BlueExtraLight' : upperFirst(camelCase(colorName))
  return getHexColorFromName(parsedColorName)
}

export function transformStat({ fields }: IContentfulStatistic): IStatisticProps {
  return {
    ...fields,
    stat: fields.statistic && fields.statistic,
    statImage: fields.statImage && fields.statImage.fields.file.url,
    description: fields.description && documentToHtmlString(fields.description),
    credit: fields.credit && { ...fields.credit.fields },
    backgroundColor: fields.backgroundColor && transformBackgroundColor(fields.backgroundColor),
    backgroundImage: fields.backgroundImage && fields.backgroundImage.fields.file.url,
    isDecorativeImage: fields.isDecorativeImage,
    variation: fields.variation && getSnakeCaseFromString(fields.variation),
  }
}
